import { render, staticRenderFns } from "./CreateScopeDialog.vue?vue&type=template&id=7bab579d&scoped=true&"
import script from "./CreateScopeDialog.vue?vue&type=script&lang=js&"
export * from "./CreateScopeDialog.vue?vue&type=script&lang=js&"
import style0 from "./CreateScopeDialog.vue?vue&type=style&index=0&id=7bab579d&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bab579d",
  null
  
)

export default component.exports